import store from 'store2'

const storageHelper = () => {
    
    const addToStorage = (key, value, local) => {
        return local ? store(key, value) : store.session(key, value)
    }

    const getFromStorage = (key, local) => {
        return local ? store.get(key) : store.session.get(key)
    }

    const removeFromStorage = (key, local) => {
        return local ? store.remove(key) : store.session.remove(key)
    }

    return {
        addToStorage,
        removeFromStorage,
        getFromStorage,
    }
}

export default storageHelper



// WEBPACK FOOTER //
// ./src/utils/storageHelper.js